const request = {
  outTime: "request timeout",
  downFail: "Download failed",
  Network: "Network error"
} 
export default request